import { Box, Grid } from "@mui/material";
import AccordianContainer from "../../CustomComponents/AccordianContainer";
import CustomTextField from "../../CustomComponents/CustomTextField";
import StlapFooter from "../../CustomComponents/StlapFooter";
import { useEffect } from "react";
import axios from "axios";
import { useState } from "react";
import { useParams } from "react-router-dom";
import PageNotFound from "../../CustomComponents/PageNotFound";
import { convertDateWithValidation } from "../helper/losDataHelper";
import CustomSpinner from "../../CustomComponents/CustomSpinner";
import { useDispatch } from "react-redux";
import { SpinnerReduerAction } from "../../Store/spinner/SpinnerReducer";

const LeadInfo = () => {
  const dispatch = useDispatch();
  const { leadId, branchCode } = useParams();
  const [leadInformation, setLeadInformation] = useState([]);
  const [invalidLeadId, setInvalidLeadId] = useState(false);

  useEffect(() => {
    loadLeadInformation();
  }, []);

  const loadLeadInformation = async () => {
    dispatch(SpinnerReduerAction.updateSpinnerFlag(true));
    let newAxiosBase = { ...axios };
    newAxiosBase.defaults.baseURL =
      process.env.REACT_APP_STLAP_LOS_DATA_BACKEND;
    try {
      await newAxiosBase
        .post("/stlap/getLeadDetailsById", { leadId, branchCode })
        .then((res) => {
          setLeadInformation(res.data);
        });
    } catch {
      setInvalidLeadId(true);
    }
    dispatch(SpinnerReduerAction.updateSpinnerFlag(false));
  };
  return (
    <>
    <CustomSpinner />
      {invalidLeadId ? (
        <PageNotFound />
      ) : (
        <Box style={{ minHeight: "calc(100vh - 120px)" }}>
          <AccordianContainer
            id="accord"
            title="Lead Information"
            initialOpen={true}
          >
            <Box sx={{ marginTop: "-1%" }}>
              <Grid container rowSpacing={0} columnSpacing={2}>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Lead ID"
                    variant="standard"
                    placeholder="Enter Lead ID"
                    disabled={true}
                    value={leadInformation.lead_id}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Branch Code"
                    variant="standard"
                    placeholder="Enter Branch Code"
                    disabled={true}
                    value={leadInformation.branch_code}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Owner User ID"
                    variant="standard"
                    placeholder="Enter Owner User ID"
                    disabled={true}
                    value={leadInformation.owner_user_id}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Lead Category ID"
                    variant="standard"
                    placeholder="Enter Lead Category ID"
                    disabled={true}
                    value={leadInformation.lead_category_id}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Lead Category Value"
                    variant="standard"
                    placeholder="Enter Lead Category Value"
                    disabled={true}
                    value={leadInformation.lead_category_value}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Lead Status ID"
                    variant="standard"
                    placeholder="Enter Lead Status ID"
                    disabled={true}
                    value={leadInformation.lead_status_id}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Lead Status Value"
                    variant="standard"
                    placeholder="Enter Lead Status Value"
                    disabled={true}
                    value={leadInformation.lead_status_value}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Status ID"
                    variant="standard"
                    placeholder="Enter Status ID"
                    disabled={true}
                    value={leadInformation.lead_status_id}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Business Name"
                    variant="standard"
                    placeholder="Enter Business Name"
                    disabled={true}
                    value={leadInformation.business_name}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Business Type ID"
                    variant="standard"
                    placeholder="Enter Business Type ID"
                    disabled={true}
                    value={leadInformation.business_type_id}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Business Category ID"
                    variant="standard"
                    placeholder="Enter Business Category ID"
                    disabled={true}
                    value={leadInformation.business_category_id}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Lead Mobile Number"
                    variant="standard"
                    placeholder="Enter Lead Mobile Number"
                    disabled={true}
                    value={leadInformation.lead_mobile}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Lead Email"
                    variant="standard"
                    placeholder="Enter Lead Email"
                    disabled={true}
                    value={leadInformation.lead_email}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Geo Address"
                    variant="standard"
                    placeholder="Enter Geo Address"
                    disabled={true}
                    value={leadInformation.geo_address}
                  />
                </Grid>
              </Grid>
            </Box>
          </AccordianContainer>

          <AccordianContainer
            id="accord"
            title="Prospect Property"
            initialOpen={true}
          >
            <Box sx={{ marginTop: "-1%" }}>
              <Grid container rowSpacing={0} columnSpacing={2}>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Prospect ID"
                    variant="standard"
                    placeholder="Enter Prospect ID"
                    disabled={true}
                    value={leadInformation.prospect_id}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Owner Type ID"
                    variant="standard"
                    placeholder="Enter Owner Type ID"
                    disabled={true}
                    value={leadInformation.owner_type_id}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="First Name"
                    variant="standard"
                    placeholder="Enter First Name"
                    disabled={true}
                    value={leadInformation.p_first_name}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Middle Name"
                    variant="standard"
                    placeholder="Enter Middle Name"
                    disabled={true}
                    value={leadInformation.p_middle_name}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Sur Name"
                    variant="standard"
                    placeholder="Enter SUR Name"
                    disabled={true}
                    value={leadInformation.p_sur_name}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="DOB"
                    variant="standard"
                    placeholder="Enter DOB"
                    disabled={true}
                    value={convertDateWithValidation(leadInformation.p_dob)}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Mobile Number"
                    variant="standard"
                    placeholder="Enter Mobile Number"
                    disabled={true}
                    value={leadInformation.p_mobile}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Mail ID"
                    variant="standard"
                    placeholder="Enter Prospect Mail"
                    disabled={true}
                    value={leadInformation.p_mail}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Occupancy ID"
                    variant="standard"
                    placeholder="Enter Occupancy ID"
                    disabled={true}
                    value={leadInformation.occupancy_id}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Employment Category"
                    variant="standard"
                    placeholder="Enter Employment Category"
                    disabled={true}
                    value={leadInformation.employment_category}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Language ID"
                    variant="standard"
                    placeholder="Enter Language ID"
                    disabled={true}
                    value={leadInformation.language_id}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Property ID"
                    variant="standard"
                    placeholder="Enter Property ID"
                    disabled={true}
                    value={leadInformation.property_id}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Nature Property ID"
                    variant="standard"
                    placeholder="Enter Nature Property ID"
                    disabled={true}
                    value={leadInformation.nature_property_id}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Property Type ID"
                    variant="standard"
                    placeholder="Enter Property Type ID"
                    disabled={true}
                    value={leadInformation.property_type_id}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Is Customer Own Property"
                    variant="standard"
                    placeholder="Enter Is Customer Own Property"
                    disabled={true}
                    value={leadInformation.is_customer_own_property}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Is Eligible"
                    variant="standard"
                    placeholder="Enter Is Eligible"
                    disabled={true}
                    value={leadInformation.p_is_eligible}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Current Loan Requirement"
                    variant="standard"
                    placeholder="Enter Current Loan Requirement"
                    disabled={true}
                    value={leadInformation.p_current_loan_requirement}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Has Outstanding Loan"
                    variant="standard"
                    placeholder="Enter Has Outstanding Loan"
                    disabled={true}
                    value={leadInformation.has_outstanding_loan}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Future Loan Requirement"
                    variant="standard"
                    placeholder="Enter Future Loan Requirement"
                    disabled={true}
                    value={leadInformation.p_future_loan_requirement}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Business Geo Tag"
                    variant="standard"
                    placeholder="Enter Business Geo Tag"
                    disabled={true}
                    value={leadInformation.business_geotag}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Residential Geo Tag"
                    variant="standard"
                    placeholder="Enter Residential Geo Tag"
                    disabled={true}
                    value={leadInformation.residential_geotag}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomTextField
                    type="text"
                    label="Permenant Geo Tag"
                    variant="standard"
                    placeholder="Enter Permenant Geo Tag"
                    disabled={true}
                    value={leadInformation.permanent_geotag}
                  />
                </Grid>
              </Grid>
            </Box>
          </AccordianContainer>
        </Box>
      )}
      <StlapFooter />
    </>
  );
};

export default LeadInfo;
